import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebook, faLinkedin, faGithub, faTelegram } from '@fortawesome/free-brands-svg-icons';
import { faUser, faHandshake } from '@fortawesome/free-regular-svg-icons';
import logo from '../assets/img/logo.svg';
import styles from '../styles/components/mobileNavbar.module.css';
import globalStyles from '../styles/global.module.css';

const MobileNavbar = () => {
  return (
    <div className={styles.mobileNavbar}>
      <div className={styles.logoContainer}>
        <img className={styles.logo} src={logo} alt="Hi-Tech Business Hub" />
      </div>
      <div className={styles.socialIcons}>
        <a className={styles.socialLink} href="https://www.instagram.com/hitechbusinesshub" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon}>
            <FontAwesomeIcon icon={faInstagram} size="lg" />
          </span>
        </a>
        <a className={styles.socialLink} href="https://www.facebook.com/Hi-Tech-Business-Hub-105515512209960" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon}>
            <FontAwesomeIcon icon={faFacebook} size="lg" />
          </span>
        </a>
        <a className={styles.socialLink} href="https://www.linkedin.com/company/hi-tech-business-hub" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon}>
            <FontAwesomeIcon icon={faLinkedin} size="lg" />
          </span>
        </a>
        <a className={styles.socialLink} href="https://github.com/hitechbusinesshub" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon}>
            <FontAwesomeIcon icon={faGithub} size="lg" />
          </span>
        </a>
        <a className={styles.socialLink} href="https://t.me/+NbqPJ1erXz0zMGIy" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon}>
            <FontAwesomeIcon icon={faTelegram} size="lg" />
          </span>
        </a>
        <a className={styles.socialLink} href="mailto:hitech.business.hub@gmail.com" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon}>
            <FontAwesomeIcon icon={faUser} size="lg" />
          </span>
        </a>
        <a className={styles.socialLink} href="https://docs.google.com/forms/d/1nFclNcpENZMT9bsmf9uTawc3NwFGKNDqhBgVsW0tWsk/viewform" target="_blank" rel="noopener noreferrer">
          <span className={styles.icon}>
            <FontAwesomeIcon icon={faHandshake} size="lg" />
          </span>
        </a>
      </div>
    </div>
  );
};

export default MobileNavbar; 